import { render, staticRenderFns } from "./User.vue?vue&type=template&id=99948d58&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99948d58')) {
      api.createRecord('99948d58', component.options)
    } else {
      api.reload('99948d58', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=99948d58&", function () {
      api.rerender('99948d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/User.vue"
export default component.exports